import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bigNumber',
  standalone: true,
})
export class BigNumberPipe implements PipeTransform {
  transform(value: number | string | null | undefined, digits: number = 1): string {
    if (value === null || value === undefined) {
      return '';
    }

    const n = typeof value === 'string' ? Number(value) : value;
    if (!Number.isFinite(n)) {
      return '';
    }

    const abs = Math.abs(n);
    const sign = n < 0 ? '-' : '';

    if (abs < 1_000) {
      return `${n}`;
    } else if (abs < 1_000_000) {
      const scaled = abs / 1_000;
      return `${sign}${this.format(scaled, digits)}k`;
    } else {
      const scaled = abs / 1_000_000;
      return `${sign}${this.format(scaled, digits)}M`;
    }
  }

  private format(num: number, digits: number): string {
    if (digits <= 0) {
      return Math.round(num).toString();
    }

    return num.toFixed(digits).replace(/\.0+$/, '').replace(/(\.\d*?)0+$/, '$1');
  }
}
